module.exports = __webpack_public_path__ + "img/SY-JB-moren.9c23ac6d.png";